import { DateFromMiliSeconds, DateTimeFromMiliSeconds } from "../helpers/timeFormats"
import React from "react"
import { T } from "../traks"


export const DaysToDeadline = ({ deadlineInMs }) => {
	const now = Math.floor((new Date()).valueOf() / 1000)
	const daystoDeadline = (parseInt(deadlineInMs) - now) / (60 * 60 * 24)
	const WholeDatesToDeadline = daystoDeadline < 0 ? Math.floor(daystoDeadline) : Math.ceil(daystoDeadline)

	const colorClass = WholeDatesToDeadline < 1 ? "bg_red-4 txt_red" : "bg_light_grey"

	return (
		<div className="d-flex align-items-center txt_blue_1">
			{DateFromMiliSeconds(deadlineInMs)}
			<div className={`border rounded-5 px-2 py-1 ms-3 lighter_grey_on_white${" "+colorClass}`}>
			{daystoDeadline !== 0 ? WholeDatesToDeadline + " " : ""}{(WholeDatesToDeadline === 1 || WholeDatesToDeadline === -1) 
				? <T>day</T>
				: daystoDeadline === 0
					? <T>today</T>
					: <T>days</T>
			} 
			</div>
		</div>
	)
}

export const PastTimeStamp = ({ TimeStampInMs }) => {
	const now = Math.floor((new Date()).valueOf() / 1000)
	const minutesAgo = Math.round((now - TimeStampInMs) / 60)
	const hoursAgo = Math.round(minutesAgo / 60)
	const daysAgo = Math.round(hoursAgo / 24)
	const weeksAgo = Math.round(daysAgo / 7)

	if (minutesAgo < 60) {
		const Minute = () => minutesAgo === 1 ? <T>minute</T> : <T>minutes</T>
		return (<>
			{minutesAgo + " "} <Minute /> <T>ago</T>
		</>)
	} else if (hoursAgo < 24) {
		const Hour = () => hoursAgo === 1 ? <T>hour</T> : <T>hours</T>
		return (<>
			{hoursAgo + " "} <Hour /> <T>ago</T>
		</>)
	} else if (daysAgo < 7) {
		const Day = () => daysAgo === 1 ? <T>day</T> : <T>days</T>
		return (<>
			{daysAgo + " "} <Day /> <T>ago</T>
		</>)
	} else if (weeksAgo < 4) {
		const Week = () => weeksAgo === 1 ? <T>week</T> : <T>weeks</T>
		return (<>
			{weeksAgo + " "}<Week /> <T>ago</T>
		</>)
	} else {
		return (<>
			{DateTimeFromMiliSeconds(TimeStampInMs)}
		</>)
	}
}

